export default {
  metadata: {
    version: '1.0.0',
    id: 'modal-desktop-1.0.0',
    name: 'JDSModalDesktopInternal',
    platform: 'web',
    description:
      'Modals focus the user’s attention exclusively on one task or piece of information via a window that sits on top of the page content. Dialog Modals are used to confirm with the user before continuing with destructive or complex actions. In this case the modal have two buttons at the bottom. Access to the rest of the UI is disabled until the modal is addressed.',
    usage:
      'A dialog modal uses two buttons and requires immediate user response.'
  },
  hierarchy: {
    container: [
      'overlay-container',
      {
        'root-container': [
          {
            'cancel-container': ['cancel-jds_button']
          },
          {
            'vertical-container': [
              {
                'header-container': ['header-jds-text']
              },
              {
                'children-container': ['children-slot']
              },
              {
                'button-container': [
                  'secondary-jds_action_button',
                  'primary-jds_action_button'
                ]
              }
            ]
          }
        ]
      },
      {
        'custom-container': ['children-slot']
      }
    ]
  },
  base: {
    container: {
      'flex-direction': '{m_0}',
      'justify-content': '{m_1}',
      'align-items': '{m_2}',
      size: '{m_3}'
    },
    'overlay-container': {
      show: true,
      size: '{m_4}',
      'background-color': '{m_5}',
      opacity: '{m_6}'
    },
    'root-container': {
      'z-index': 1,
      'flex-direction': '{m_7}',
      'justify-content': '{m_8}',
      'align-items': '{m_9}',
      'border-radius': '{m_10}',
      'background-color': '{elevation1}',
      width: '{custom_27}',
      'max-height': '{m_12}'
    },
    'cancel-container': {
      'flex-direction': '{m_13}',
      'justify-content': '{m_14}',
      'align-items': '{m_15}',
      width: '{m_16}',
      'padding-top': '{m_17}',
      'padding-bottom': '{m_18}',
      'padding-left': '{m_19}',
      'padding-right': '{m_20}',
      hidden: false
    },
    'cancel-jds_button': {
      hidden: false,
      icon: 'ic_close',
      kind: 'tertiary',
      size: 'medium'
    },
    'vertical-container': {
      'flex-direction': '{m_21}',
      'justify-content': '{m_22}',
      'align-items': '{m_23}',
      'padding-left': '{m_24}',
      'padding-right': '{m_25}',
      'padding-bottom': '{m_26}',
      width: '{m_27}',
      overflow: '{m_28}'
    },
    'header-container': {
      'flex-direction': '{m_30}',
      'justify-content': '{m_31}',
      'align-items': '{m_32}',
      width: '{m_33}',
      'padding-bottom': '{m_34}'
    },
    'children-container': {
      width: '{m_35}',
      overflow: '{m_36}'
    },
    'button-container': {
      width: '{m_37}',
      'justify-content': '{m_38}',
      'align-items': '{m_39}',
      'flex-direction': '{m_40}',
      gap: '{m_41}',
      'padding-top': '{m_42}'
    },
    'primary-jds_action_button': {
      hidden: false,
      kind: 'primary',
      size: 'large',
      stretch: false
    },
    'secondary-jds_action_button': {
      hidden: false,
      kind: 'secondary',
      size: 'large',
      stretch: false
    },
    'custom-container': {
      hidden: true,
      'z-index': 1,
      'flex-direction': '{m_43}',
      'justify-content': '{m_44}',
      'align-items': '{m_45}',
      'border-radius': '{m_46}',
      'background-color': '{elevation1}',
      'padding-left': '{m_48}',
      'padding-right': '{m_49}',
      'padding-top': '{m_50}',
      'padding-bottom': '{m_51}',
      width: '{m_52}',
      'max-height': '{m_53}',
      overflow: '{m_29}'
    },
    'header-jds-text': {
      'font-family': '{text_86}',
      color: '{text_20}',
      'font-size': '{text_85}',
      'line-height': '{text_87}',
      'letter-spacing': '{text_88}',
      'font-weight': '{text_89}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    kind: {
      acknowledgement: {
        'primary-jds_action_button': {
          stretch: true
        },
        'secondary-jds_action_button': {
          hidden: true
        },
        'header-jds-text': {
          'text-align': 'center',
          flex: 1
        }
      },
      informational: {
        'button-container': {
          hidden: true
        }
      },
      custom: {
        'custom-container': {
          hidden: false
        },
        'root-container': {
          hidden: true
        }
      }
    },
    headerAlignment: {
      right: {
        'header-container': {
          'justify-content': '{m_54}'
        }
      },
      center: {
        'header-container': {
          'justify-content': '{m_55}'
        }
      }
    },
    size: {
      small: {
        'vertical-container': {
          'padding-left': '{m_56}',
          'padding-right': '{m_57}',
          'padding-bottom': '{m_58}'
        }
      }
    },
    primaryCtaDisabled: {
      true: {
        'primary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    secondaryCtaDisabled: {
      true: {
        'secondary-jds_action_button': {
          state: 'disabled'
        }
      }
    },
    _hasCta: {
      false: {
        'button-container': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      dialog: {
        false: {
          'cancel-container': {
            hidden: true
          },
          'vertical-container': {
            'padding-top': '{m_59}'
          }
        }
      },
      acknowledgement: {
        false: {
          'cancel-container': {
            hidden: true
          },
          'vertical-container': {
            'padding-top': '{m_60}'
          }
        }
      }
    },
    {
      medium: {
        desktop: {
          'root-container': {
            width: '584'
          }
        },
        tablet: {
          'root-container': {
            width: '464'
          }
        }
      },
      small: {
        desktop: {
          'root-container': {
            width: '412'
          }
        },
        tablet: {
          'root-container': {
            width: '412'
          }
        }
      }
    }
  ],
  combination_config: [
    ['kind', 'isCloseable'],
    ['size', '_platform']
  ],
  api: {
    config: {
      kind: {
        values: ['dialog', 'acknowledgement', 'informational', 'custom'],
        doc_description:
          'It can be used to switch between 3 variants of Modal. `informational` modal has no buttons,`dialog` modal has two buttons, `acknowledgement` modal has only a single button.'
      },
      size: {
        values: ['medium', 'small'],
        doc_description:
          'It can be used to control the size of popup container.'
      },
      headerAlignment: {
        values: ['left', 'right', 'center'],
        doc_description: 'It is used to align header of Modal.'
      },
      isCloseable: {
        values: [true, false],
        doc_description:
          'It can be used to makes Modal closeable, displays close icon button on popup.'
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      },
      _platform: {
        values: ['desktop', 'tablet']
      },
      _hasCta: {
        values: [true, false]
      }
    },
    data: {
      'primary-jds_action_button': {
        label: {
          type: 'string',
          name: 'primaryCTA',
          doc_description: 'It displays label of primary button of Modal.'
        }
      },
      'secondary-jds_action_button': {
        label: {
          type: 'string',
          name: 'secondaryCTA',
          doc_description: 'It displays label of secondary button of Modal.'
        }
      },
      'header-jds-text': {
        value: {
          type: 'string',
          name: 'header',
          doc_description: 'It displays the title of modal.'
        }
      }
    },
    children: {
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        max: 1,
        doc_description:
          'This sets Modal content as a children elements eg. `<Modal> <Table /> <Modal/>`'
      }
    },
    events: {
      'root-container': {
        onClick: 'onModalClick'
      },
      'custom-container': {
        onClick: 'onModalClick'
      },
      'cancel-jds_button': {
        onClick: 'onCancel'
      },
      'primary-jds_action_button': {
        onClick: 'onPrimaryClick'
      },
      'secondary-jds_action_button': {
        onClick: 'onSecondaryClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'dialog'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Modal Content'
          },
          'aria-modal': {
            name: '_ariaModal',
            value: 'true'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'cancel-jds_button': {
        properties: {
          ariaLabel: {
            name: 'cancelButtonCtaAriaLabel',
            value: 'Close Modal'
          }
        }
      },
      'primary-jds_action_button': {
        properties: {
          ariaLabel: 'primaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'secondary-jds_action_button': {
        properties: {
          ariaLabel: 'secondaryCtaAriaLabel',
          ariaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
